import BaseContainer from "@base/container/BaseContainer";
import {Signals} from "@/Imports";
import gsap, {Power2} from "gsap";
import AddComponent from "@base/utils/AddComponent";
import {GlowFilter} from "@pixi/filter-glow";
import Facade from "@/Facade";
import Utils from "@base/utils/Utils";
import Config from "@/config/Config";
import FormatData from "@/application/FormatData";

export default class MultiplierContainer extends BaseContainer {

  constructor(data) {
    super(data)
    this.init()
  }

  init(data) {
    this.heapText = []
    Signals.startCountingUpInterimWinnings.add(this.onStartShowInterimWinnings, this)

    Utils.applyFromPattern(this, Config.pattern.reels)
    // надпись Multiplayer
    this.multiplierCaption = AddComponent.addElement('multiplier_board', this, [0, 30], 'bonus')
    this.multiplierCaption.name = "Multiplier board"
    // панель для аквариума в портретке
    this.multiplierPortraite = AddComponent.addElement('multiplier_box', this, [0, 0], 'bonus')
    // текст на аквариуме
    this.multiplierCaptionText = AddComponent.addElementText('multiplier', 'forMultiplier', this, [0, 0]);
    this.multiplierCaptionText.anchor.set(0.5, 0.5);

    //дощечка сверху
    this.winContainer = AddComponent.addElement('win_container', this, [0, -100], 'bonus')
    // аквариум стоящий рядышком с полем в десктопе
    this.fishbowl = AddComponent.addElement('multiplier_symbol', this, [-30, 0], 'bonus')
    this.fishbowlSmallPortraite = AddComponent.addElement('multipiler_symbol_small', this, [0, 0], 'bonus')


    const fontWite = {
      "fill": "white", "fontFamily": "Roboto", "align": "center", "fontSize": 60
    }
    const filters = [new GlowFilter({distance: 10, outerStrength: 2, color: 0x009977})];
    const bigCaptionStyle = {font: {name: 'fontMultiplier', size: '70px'}, align: 'center'}

    this.multiplierXFly = AddComponent.addElementBitmapText('', bigCaptionStyle, this.fishbowl, [180, 200])
    this.multiplierXFly.name = 'multiplierXFly'
    //показывается когда текст multiplier прилетел
    this.textWinMultiplyer = AddComponent.addElementBitmapText('', bigCaptionStyle, this.winContainer, [490, 50])
    this.textWinMultiplyer.alpha = 0
    this.textWinMultiplyer.name = 'textWinMultiplyer'
    //this.textWinScore = AddComponent.addElementBitmapText('', bigCaptionStyle, this.winContainer, [160, 50])
    //показывается когда текст выигрыша прилетел
    this.textWinScore = AddComponent.addElementDynamicStyleText(fontWite, this.winContainer, [200, 50])
    this.textWinScore.alpha = 0
    this.textWinScore.name = 'textWinScore'
    // показывается после объединения всех выигрышей
    // this.textWinAllScore = AddComponent.addElementBitmapText('', bigCaptionStyle, this.winContainer, [220, 50])
    this.textWinAllScore = AddComponent.addElementDynamicStyleText(fontWite, this.winContainer, [300, 50])
    this.textWinAllScore.alpha = 0
    this.textWinAllScore.name = 'textWinAllScore'

    this.flyMultiplayerPosition = {x: -440, y: -700}

    Signals.startSpin.add(this.clearNewSpin, this)
    Signals.bonusMultiplierChange.add(this.onShowMultiplier, this)
    Signals.bonusMultiplierFly.add(this.onMultiplierFly, this)
    //Signals.bonusMultiplierShowTextWinScore.add(this.onShowTextWinScore, this)

    //fishbowl
    this.bowlAnimation = AddComponent.addSpineAnimation('fishBowl', 'animation', this, [850, 200]);
    this.bowlAnimation.visible = false;
    this.onOrientationChanged(Facade.orientation)
    Signals.orientationChanged.add(this.onOrientationChanged, this)

    this.featureWin = AddComponent.addSpineAnimation('feature_win', 'feature_Win_ani', this.winContainer, [250, 50])
    this.multiplierPosition = AddComponent.addSpineAnimation('multiplier_position', 'animation', this, [850, 200]);
    this.prevMultiplier = 0;

  }

  clearNewSpin() {
    this.textWinMultiplyer.alpha = 0
    this.textWinScore.alpha = 0
    this.textWinAllScore.alpha = 0
    this.prevMultiplier = 0;
  }

  onShowMultiplier(value) {
    const textMultiplier = (value.count === 0 || value.count === 1) ? '' : 'X' + value.count
    this.multiplierXFly.alpha = 1
    this.textWinMultiplyer.alpha = 0
    this.multiplierXFly.text = textMultiplier
    this.textWinMultiplyer.text = textMultiplier
    if (this.prevMultiplier !== value.count && value.count > 1) {
      Signals.playMultiplierTickup.dispatch();
      this.prevMultiplier = value.count;
    }
  }

  onMultiplierFly() {
    this.magicMultiplier()
  }

  magicMultiplier = async () => {
    const flyMultiplayer = () => {
      return new Promise(resolve => {
        Signals.playTrail.dispatch();
        this.multiplierXFly.alpha = 1
        this.multiplierPosition.start(['animation'], [false])
        const positionTextCount = {x: this.multiplierXFly.x, y: this.multiplierXFly.y}
        gsap.to(this.multiplierXFly, {
          duration: 0.9,
          x: this.flyMultiplayerPosition.x, y: this.flyMultiplayerPosition.y, ease: "",
          onComplete: () => {
            this.multiplierXFly.alpha = 1
            this.multiplierXFly.position.set(positionTextCount.x, positionTextCount.y)
            this.textWinMultiplyer.alpha = 1
            resolve()
          }
        })
      })
    }
    const showCommonResult = () => {
      return new Promise(resolve => {

        this.featureWin.start(['feature_Win_ani'], [false])
        this.textWinAllScore.alpha = 0
        this.textWinAllScore.text = FormatData.formatToCoins(Facade.model.winCurrency)
        console.log(' MC  :  showCommonResult  ', this.textWinAllScore.text)
        gsap.to(this.textWinAllScore, 0.4, {alpha: 1})
        gsap.to(this.textWinMultiplyer, 0.3, {alpha: 0})
        gsap.to(this.textWinScore, 0.3, {alpha: 0})

        // console.log(' MC  :  showCommonResultIW  ', Facade.model.winCurrency,  FormatData.formatToCoins(Facade.model.winCurrency))
        // this.textWinAllScore.alpha = 0
        // this.textWinAllScore.text = FormatData.formatToCoins(Facade.model.winCurrency)
        // gsap.to(this.textWinAllScore, 0.6, {alpha: 1})
        console.log("MULT APPLY");
        Signals.playMultiplierApply.dispatch();
        gsap.delayedCall(0.7, () => {
          resolve()
        })
      })
    }
    console.log(' MC  :  magicMultiplier  ')
    // await showTextWinScoreGlobal()
    await flyMultiplayer()
    await showCommonResult()
  }

  onStartShowInterimWinnings(data) {
    console.log(' MC  :  onStartShowInterimWinnings  ', data)
    const isMultiplier = data.upper
    this.textWinAllScore.alpha = 0  //TODO : переделать потому что очищается до того как идёт появление
    this.startShowInterimWinnings(data.winnings, data.curentlySum, data.position, isMultiplier, data.bonusFly)
  }

  async startShowInterimWinnings(score, scoreCommon, position, isMultiplier, isBonusFly) {

    const flyMultiplayer = () => {
      return new Promise(resolve => {
        Signals.playTrail.dispatch();
        this.multiplierXFly.alpha = 1
        this.multiplierPosition.start(['animation'], [false])
        const positionTextCount = {x: this.multiplierXFly.x, y: this.multiplierXFly.y}
        gsap.to(this.multiplierXFly, 0.7, {
          x: this.flyMultiplayerPosition.x, y: this.flyMultiplayerPosition.y, ease: "",
          onComplete: () => {
            this.multiplierXFly.alpha = 1
            this.multiplierXFly.position.set(positionTextCount.x, positionTextCount.y)
            this.textWinMultiplyer.alpha = 1
            resolve()
          }
        })
      })
    }

    const moveMutiplier = (winText, position) => {
      return new Promise(resolve => {
        gsap.to(winText.scale, {duration: 0.9, x: 1, y: 1})
        gsap.to(winText, {
          duration: 0.9,
          x: this.winContainer.x + position.x,
          y: this.winContainer.y + position.y,
          onComplete: () => {
            gsap.to(winText, {
              duration: 0.9,
              alpha: 0,
              onComplete: () => winText.visible = false
            })
            resolve()
          }
        })
      })
    }

    const showSmallWinNumbers = async (winText) => {
      return new Promise(resolve => {
        gsap.to(winText.scale, {
          duration: 0.4,
          x: 1.4,
          y: 1.4,
          ease: Power2.easeOut, onComplete: async () => {
            await moveMutiplier(winText, this.textWinFlyCenteredPosition)
            resolve()
          }
        })
      })
    }

    const getWinText = (winningCountText, position) => {
      let freeWinTextElement = this.heapText.find((winText) => winText.visible === false)
      const fontWite = {
        "fill": "white", "fontFamily": "Roboto", "align": "center", "fontSize": 60
      }
      if (!freeWinTextElement) {
        const newElementText = AddComponent.addElementDynamicStyleText(fontWite, this, [0, 0])
        // newElementText.anchor.set(0.5)
        newElementText.visible = true
        this.heapText.push(newElementText)
        freeWinTextElement = newElementText
      }
      freeWinTextElement.alpha = 1
      freeWinTextElement.visible = true
      freeWinTextElement.text = winningCountText
      freeWinTextElement.position.set(position.x, position.y)
      return freeWinTextElement
    }

    const showCommonResultIW = (scoreCommon, isBonusFly) => {
      return new Promise(resolve => {
        this.textWinScore.text = FormatData.formatToCoins(scoreCommon)//Facade.model.getWinCoinsSum()
        this.textWinScore.x = this.textWinScorePosition.x
        gsap.to(this.textWinScore, {duration: 0.2, alpha: 1})

        if (isBonusFly) {
          this.featureWin.start(['feature_Win_ani'], [false])
          this.textWinAllScore.alpha = 0
          this.textWinAllScore.text = FormatData.formatToCoins(Facade.model.winCurrency)
          gsap.to(this.textWinAllScore, {duration: 0.4, alpha: 1})
          gsap.to(this.textWinMultiplyer, {duration: 0.3, alpha: 0})
          gsap.to(this.textWinScore, {duration: 0.3, alpha: 0})

          Signals.playMultiplierApply.dispatch();
          gsap.delayedCall(0.7, () => resolve())
        }
      })
    }

    const reels = Config.pattern.reels.reels
    const textWinning = FormatData.formatToCoins(score)
    const positionWinning = {x: reels[position.x].x + 100, y: reels[0].y + 200 * position.y}

    await showSmallWinNumbers(getWinText(textWinning, positionWinning))
    if (isBonusFly) {
      await flyMultiplayer()
    }
    await showCommonResultIW(scoreCommon, isBonusFly)
  }

  onOrientationChanged(orientationSymbol) {
    switch (orientationSymbol) {
      case 'Hd':
        this.fishbowlSmallPortraite.visible = false
        this.multiplierPortraite.visible = false
        this.multiplierCaption.visible = true
        this.multiplierCaptionText.visible = true
        this.fishbowl.visible = true
        this.fishbowl.position.set(1070, 520)
        this.multiplierCaption.position.set(1050, 450)
        this.multiplierCaptionText.position.set(1250, 495)
        this.winContainer.position.set(140, -210)
        this.fishbowl.addChild(this.multiplierXFly)
        this.multiplierXFly.position.set(205, 195)
        this.bowlAnimation.position.set(1070, 520)
        this.multiplierXFly.scale.x = 1;
        this.multiplierXFly.scale.y = 1;
        this.flyMultiplayerPosition = {x: -440, y: -680}

        // Small win texts that flying to the top center position
        this.textWinFlyCenteredPosition = {x: 290, y: 50}
        // Then slide to the left in the case of multiplier
        this.textWinFlyLeftPosition = {x: 250, y: 60}

        this.textWinAllScore.position.set(307, 50)
        this.textWinScorePosition = {x: 290, y: 60}

        break;
      case 'Hm':
        this.fishbowlSmallPortraite.visible = false
        this.multiplierPortraite.visible = false
        this.fishbowl.visible = true
        this.multiplierCaption.visible = true
        this.multiplierCaptionText.visible = true
        this.fishbowl.position.set(960, 520)
        this.multiplierCaption.position.set(1000, 450)
        this.multiplierCaptionText.position.set(1160, 495)
        this.winContainer.position.set(140, -210)
        this.fishbowl.addChild(this.multiplierXFly)
        this.multiplierXFly.position.set(200, 190)
        this.multiplierXFly.scale.x = 1;
        this.multiplierXFly.scale.y = 1;
        this.flyMultiplayerPosition = {x: -335, y: -675}

        // Small win texts that flying to the top center position
        this.textWinFlyCenteredPosition = {x: 290, y: 50}
        // Then slide to the left in the case of multiplier
        this.textWinFlyLeftPosition = {x: 250, y: 60}

        this.textWinAllScore.position.set(290, 50)
        this.textWinScorePosition = {x: 290, y: 60}
        break
      case 'Vm':
        this.multiplierPortraite.visible = true
        this.multiplierCaption.visible = false
        this.multiplierCaptionText.visible = true
        this.fishbowlSmallPortraite.visible = true
        this.fishbowl.visible = false
        //  this.fishbowl.scale.set(0.6)
        this.multiplierPortraite.position.set(610, -380)
        this.multiplierCaptionText.position.set(835, -335)
        this.fishbowlSmallPortraite.position.set(750, -310)
        this.winContainer.position.set(-80, -260)
        this.winContainer.scale.set(1.2)
        this.fishbowlSmallPortraite.addChild(this.multiplierXFly)
        this.multiplierXFly.position.set(75, 100)
        this.multiplierXFly.scale.x = 0.7;
        this.multiplierXFly.scale.y = 0.7;
        this.flyMultiplayerPosition = {x: -260, y: 100}

        // Small win texts that flying to the top center position
        this.textWinFlyCenteredPosition = {x: 345, y: 60}
        // Then slide to the left in the case of multiplier
        this.textWinFlyLeftPosition = {x: 240, y: 60}

        this.textWinAllScore.position.set(315, 50)
        this.textWinScorePosition = {x: 300, y: 70}
        break
    }
  }
}
